<template>
  <div>
    <TopHeader class="bg-color-wrap" />
    <MainNavbar />
    <PageBanner pageTitle="Blog Details" />
    <BlogDetails />
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layout/TopHeader";
import MainNavbar from "../Layout/MainNavbar";
import PageBanner from "../Common/PageBanner";
import BlogDetails from "../BlogDetails/BlogDetails";
import MainFooter from "../Layout/MainFooter";

export default {
  name: "BlogDetailsPage",
  components: {
    TopHeader,
    MainNavbar,
    PageBanner,
    BlogDetails,
    MainFooter,
  },
};
</script>